<template>
  <div
    class="qr-code"
    v-if="detail && detail.qrCodeVo && detail.qrCodeVo.sourceCode"
  >
    <div class="header">
      <div class="label">访客：{{ detail.personName || userName }}</div>
      <div class="control" @click="toDetail">
        详情
        <van-icon name="arrow" />
      </div>
    </div>
    <div class="body">
      <div class="code-box">
        <div class="qr" :class="isLoseEfficacy ? 'lose-efficacy' : ''">
          <vue-qr :text="detail.qrCodeVo.sourceCode" :size="240"></vue-qr>
          <span class="tip" v-if="false">已失效，请刷新！</span>
        </div>
        <p class="time">
          <span class="text">{{ detail.applicationDate ? detail.applicationDate.substring(0, 16) : '' }}</span>
          <span class="remark">{{
            detail.applicationDate ? " (当天有效)" : ""
          }}</span>
        </p>
        <div class="control" v-if="false" @click="refreshQR">
          <van-icon name="replay" />刷新
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="left" @click="toApplyRecord">
        <van-image
          width="28"
          height="28"
          :src="require('@/assets/image/loginQR/list.png')"
        />
        <span>申请记录</span>
      </div>
      <div class="right" @click="toApply">
        <van-image
          width="28"
          height="28"
          :src="require('@/assets/image/loginQR/apply.png')"
        />
        <span>申请访客</span>
      </div>
    </div>
  </div>
  <div class="qr-code no-data" v-else>
    <div class="header">
      <div class="label">访客：{{ detail.personName || userName }}</div>
    </div>
    <div class="body">
      <div class="code-box">
        <van-image
          width="180"
          height="150"
          :src="require('@/assets/image/no-data.png')"
        />
        <p class="time">没有访客码~~</p>
        <van-button class="van-button" color="#4174FD" plain @click="toApply"
          >申请访客</van-button
        >
      </div>
    </div>
    <div class="footer">
      <div class="left" @click="toApplyRecord">
        <van-image
          width="28"
          height="28"
          :src="require('@/assets/image/loginQR/list.png')"
        />
        <span>申请记录</span>
      </div>
      <div class="right" @click="toApply">
        <van-image
          width="28"
          height="28"
          :src="require('@/assets/image/loginQR/apply.png')"
        />
        <span>申请访客</span>
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr/src/packages/vue-qr.vue"
import { ref, toRefs, watch } from "vue"
import { useRouter } from "vue-router"
export default {
  name: "LoginQRCode",
  props: {
    userName: {
      type: String,
      default: "",
    },
    detail: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  components: {
    VueQr,
  },
  setup(props, { emit }) {
    const router = useRouter()

    const { detail } = toRefs(props)

    const isLoseEfficacy = ref(false)
    const lostEfficacy = () => {
      setTimeout(() => {
        isLoseEfficacy.value = true
      }, 60 * 1000 * 15)
    }
    const refreshQR = () => {
      emit("refreshQR", detail.value.id)
    }

    const refreshStatus = (status) => {
      isLoseEfficacy.value = status
    }

    const toApplyRecord = () => {
      router.push({
        path: "/visitorRecord",
      })
    }

    const toApply = () => {
      router.push({
        path: "/visitorApply",
      })
    }

    const toDetail = () => {
      router.push({
        path: "/visitorRecordDetail",
        query: {
          id: detail.value.id,
        },
      })
    }

    watch(
      detail,
      (newVal) => {
        if (newVal && newVal.qrCodeVo && newVal.qrCodeVo.sourceCode) {
          isLoseEfficacy.value = false
          lostEfficacy()
        }
      },
      {
        immediate: true,
      }
    )

    return {
      isLoseEfficacy,
      refreshStatus,
      refreshQR,
      toApplyRecord,
      toApply,
      toDetail,
    }
  },
}
</script>

<style lang="less" scoped>
.qr-code {
  box-sizing: border-box;
  width: 345px;
  // height: 442px;
  background: #ffffff;
  border-radius: 16px;
  margin: 0 auto;
  margin-top: 60px;
  padding: 0 16px;
  &.no-data {
    .body {
      .time {
        color: #999;
        font-size: 13px;
        margin-top: 2px;
      }
      .van-button {
        width: 165px;
        height: 36px;
        border-radius: 18px;
        border: 1px solid #4174fd;
        margin: 24px auto;
      }
    }
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 54px;
    font-size: 15px;
    .label {
      color: #333;
      font-weight: 600;
    }
    .control {
      color: #999;
      font-weight: 400;
      text-align: right;
    }
  }
  .body {
    text-align: center;
    font-size: 15px;
    font-weight: 400;
    .code-box {
      .qr {
        position: relative;
        &.lose-efficacy {
          .tip {
            color: #fe4f54;
            background-color: rgba(255, 255, 255, 0.8);
          }
        }
        .tip {
          position: absolute;
          display: flex;
          width: 100%;
          height: 100%;
          align-items: center;
          justify-content: center;
          left: 0;
          top: 0;
          color: transparent;
        }
      }
    }
    .time {
      color: #999;
      margin: 12px auto;
    }
    .control {
      color: #4174fd;
      margin-bottom: 16px;
    }
  }
  .footer {
    display: flex;
    height: 54px;
    color: #333;
    font-size: 15px;
    font-weight: 400;
    border-top: 1px solid #e5e5e5;
    margin: 0 -16px;
    margin-top: 16px;
    .left,
    .right {
      position: relative;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin-left: 8px;
      }
    }
    .left:after {
      position: absolute;
      top: calc(50% - 10px);
      right: 0;
      content: "";
      display: inline-block;
      width: 1px;
      height: 20px;
      background: #d8d8d8;
    }
  }
}
</style>
